module.exports = __webpack_public_path__ + "static/media/American Heart Association.0a9face4.png";